import React, { useEffect, useState } from 'react';
import BreadcrumbsHelper from './helpers/index';
import { CONTENT_SUITE, PROPERTY_SEARCH, CHAIN } from '@constants/index';
import 'Styles/breadcrumbs.scss';

const Breadcrumbs = () => {
  const [route, setRoute] = useState<string>('');
  const [supplier, setSupplier] = useState<string>('');
  const [propertyName, setPropertyName] = useState<string>('');
  const [path, setPath] = useState<boolean>(false);
  const [userInfo, setUserInfo] = useState<any>({});
  const [isMounted, setIsMounted] = useState<boolean>(true);

  useEffect(() => {
    const init = new BreadcrumbsHelper(
      route,
      isMounted,
      setRoute,
      setSupplier,
      setPropertyName,
      setPath,
      setUserInfo
    );
    init.addEventListenersHanlder();
    init.setSession();
    return () => {
      // on unmount removing session data
      setIsMounted(false);
      init.removeEventListenerHandler();
    };
  }, [isMounted, route]);

  const forceUpdateFromBreadcrumb = () => {
    return window.forceRender();
  };

  return (
    <div className="breadcrumbs">
      {/* Global Breadcrumbs */}
      <div className={userInfo?.view ? 'd-none' : 'sub_container'}>
        <h3 className="sub_title"> {CONTENT_SUITE} </h3>
        <h1 className="main_title">
          <a href="/listing">{PROPERTY_SEARCH}</a>
        </h1>
      </div>
      <div className={propertyName && !path ? 'breadcrubms-header' : 'd-none'}>
        <div className="sub_container reference_position">
          <h3 className="sub_title"> {CHAIN} </h3>
          <h1 className="sub_main_title"> {supplier} </h1>
        </div>
      </div>
      <div className={propertyName && !path ? 'breadcrubms-header' : 'd-none'}>
        <div className="sub_container">
          <h3 className="sub_title">Property</h3>
          <h1 className="sub_main_title">{propertyName}</h1>
        </div>
      </div>
      <div className={route ? 'breadcrubms-header' : 'd-none'}>
        <div className="sub_container">
          <h3 className="sub_title">Category</h3>
          <h1
            className="sub_main_title cursor_pointer underline"
            onClick={() => forceUpdateFromBreadcrumb()}
          >
            {route}
          </h1>
        </div>
      </div>

      {/* User Breadcrumbs */}
      <div className={userInfo?.view ? 'sub_container' : 'd-none'}>
        <h3 className="sub_title"> {CONTENT_SUITE} </h3>
        <h1 className="main_title">
          <a href={window.location.pathname}>{userInfo?.title}</a>
        </h1>
      </div>
      {userInfo?.subValue && (
        <div className={userInfo?.view ? 'breadcrubms-header' : 'd-none'}>
          <div className="sub_container reference_position">
            <h3 className="sub_title"> {userInfo?.subValue} </h3>
            <h1 className="sub_main_title"> {userInfo?.value} </h1>
          </div>
        </div>
      )}
    </div>
  );
};

export default Breadcrumbs;
